var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 21,
    viewBox: "0 0 10 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.34077 20.8786C8.12731 20.8793 7.9164 20.8322 7.72354 20.7407C7.53068 20.6493 7.36076 20.5158 7.22628 20.35L0.325041 11.7794C0.114887 11.5238 0 11.2032 0 10.8724C0 10.5415 0.114887 10.2209 0.325041 9.96531L7.46918 1.39469C7.71171 1.10298 8.06022 0.919531 8.43804 0.884707C8.81586 0.849882 9.19204 0.966531 9.48383 1.20899C9.77562 1.45145 9.95912 1.79986 9.99395 2.17758C10.0288 2.5553 9.91211 2.93138 9.66958 3.22309L3.28272 10.8795L9.45526 18.5359C9.62998 18.7456 9.74096 19.0009 9.77508 19.2717C9.8092 19.5424 9.76503 19.8173 9.64779 20.0637C9.53054 20.3102 9.34514 20.5179 9.11351 20.6623C8.88188 20.8067 8.61372 20.8818 8.34077 20.8786Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowIcon);
export default __webpack_public_path__ + "static/media/right-arrow-icon.b9b67b98f1d84bcc46ea2b1f07cc4bc0.svg";
export { ForwardRef as ReactComponent };